import { render, staticRenderFns } from "./stars-rating.vue?vue&type=template&id=9b23a182&"
import script from "./stars-rating.vue?vue&type=script&lang=js&"
export * from "./stars-rating.vue?vue&type=script&lang=js&"
import style0 from "./stars-rating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b23a182')) {
      api.createRecord('9b23a182', component.options)
    } else {
      api.reload('9b23a182', component.options)
    }
    module.hot.accept("./stars-rating.vue?vue&type=template&id=9b23a182&", function () {
      api.rerender('9b23a182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-stats/stars-rating.vue"
export default component.exports